import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton, IonCol, IonGrid, IonRow } from '@ionic/angular/standalone';
import { SchoolAttendanceViewModel } from 'src/app/models/school.model';
import { SelectStudentEventPayload } from '../../models/event-payloads.model';
import { ButtonPillComponent } from '../button-pill/button-pill.component';
import { QuicklinkComponent } from '../quicklink/quicklink.component';
import { RoundImageClearButtonComponent } from '../round-image-clear-button/round-image-clear-button.component';
import { SchoolLogoComponent } from '../school-logo/school-logo.component';
import { StudentItemListComponent } from '../student-item-list/student-item-list.component';

@Component({
  selector: 'app-school-detail',
  templateUrl: './school-detail.component.html',
  styleUrls: ['./school-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SchoolLogoComponent,
    StudentItemListComponent,
    ButtonPillComponent,
    RoundImageClearButtonComponent,
    QuicklinkComponent,
    IonGrid,
    IonRow,
    IonCol,
    IonButton
  ]
})
export class SchoolDetailComponent {
  @Input() school: SchoolAttendanceViewModel;
  @Output() selectSchoolOnboarding = new EventEmitter<number>();
  @Output() selectChannel = new EventEmitter<number>();
  @Output() selectStudent = new EventEmitter<SelectStudentEventPayload>();
  @Output() selectSchoolContactDetails = new EventEmitter<number>();
  @Output() editChannels = new EventEmitter<number>();
  @Output() editContactDetails = new EventEmitter<number>();
  @Output() viewChannelList = new EventEmitter();
  @Output() viewQuicklinkList = new EventEmitter();
  @Output() openLink = new EventEmitter<string>();

  onShowContactInfo(): void {
    this.selectSchoolContactDetails.emit(this.school.id);
  }

  onShowStudent(student: SelectStudentEventPayload): void {
    this.selectStudent.emit(student);
  }

  onShowChannel(): void {
    this.selectChannel.emit(this.school.feedChannelId);
  }

  onContinueOnboarding(): void {
    this.selectSchoolOnboarding.emit(this.school.id);
  }

  onEditChannels(): void {
    this.editChannels.emit(this.school.id);
  }

  onUpdateContactDetails(): void {
    this.editContactDetails.emit(this.school.id);
  }

  onViewChannelList(): void {
    this.viewChannelList.emit();
  }

  onViewQuickLinkList(): void {
    this.viewQuicklinkList.emit();
  }

  trackByFn(_: number, item: any): number {
    return _;
  }

  onOpenLink(link: string): void {
    this.openLink.emit(link);
  }

  generateQuicklinkURL(iconUrl: string, url: string): string {
    if (iconUrl.endsWith('/api/asset/icon/email')) {
      return `mailto:${url}`;
    }

    return url;
  }
}
